<template>
  <div
    class="desktop-view page admin-inner-page"
  >
    <div class="sensata-splash-wrapper" @click="goToAdmin()">
      <SensataSplash></SensataSplash>
    </div>

    <div class="collecting-data-wrapper">
      <span class="collecting-dot" :class="{'active': collecting}" @click="stopCollecting()"></span>
    </div>

    <div class="admin-content-wrapper delay-entry">
      <div v-if="loggedIn && authorized">
        <h2 class="survey-name">{{surveyName}}</h2>
        <div class="responses">
          <transition mode="out-in" name="bounce">
            <div :key="filtered.length">
              ({{filtered.length | responseText}})
            </div>
          </transition>
        </div>
      </div>
      <section class="view-section delay-entry delay-like-crazy">
        <p v-if="loggedIn && !authorized">No tienes autorización para ver esta página. Solicita tu acceso al administrador.</p>

        <div v-if="loggedIn && authorized">
          <div class="toolbar">
            <div class="main-toolbar">
              <div class="date-selector-wrapper">
                <el-date-picker
                  ref="dateSelectorFrom"
                  v-model="startDatetime"
                  type="datetime"
                  placeholder="Select date and time"
                  :clearable="false"
                  size="large"
                  :key="`date_picker_from_${randomString}`"
                ></el-date-picker>
                <el-date-picker
                  ref="dateSelectorTo"
                  v-model="endDatetime"
                  type="datetime"
                  placeholder="End date and time"
                  :clearable="true"
                  size="large"
                  :key="`date_picker_to_${randomString}`"
                ></el-date-picker>
              </div>
              <div class="view-switcher">
                <div class="secondary-controls">
                  <div class="icon-wrapper icon-reload" @click="fetchSurveys()">
                    <Icons class="icon" icon="reload" size="44" color="#5d2466"></Icons>
                  </div>
                  <div class="icon-wrapper icon-reload" @click="downloading || view === 'profileStats' ? '': downloadTable(view)">
                    <Icons class="icon" icon="download-data" size="44" color="#5d2466" :class="{'disabled': downloading || view === 'profileStats'}"></Icons>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{'active-view': showingFilters}"
                    @click="showingFilters = !showingFilters"
                  >
                    <Icons class="icon" icon="filter" size="44" color="#5d2466"></Icons>
                  </div>
                </div>

                <div
                  class="icon-wrapper"
                  :class="{'active-view': view === 'profileStats'}"
                  @click="activateView('profileStats')"
                  v-if="profiles"
                >
                  <Icons class="icon" icon="face" size="44" color="#5d2466"></Icons>
                </div>
                <div
                  class="icon-wrapper"
                  :class="{'active-view': view === 'leaderboard'}"
                  @click="activateView('leaderboard')"
                  v-if="profiles"
                >
                  <Icons class="icon" icon="medal" size="40" color="#5d2466"></Icons>
                </div>
                <div
                  class="icon-wrapper"
                  :class="{'active-view': view === 'all'}"
                  @click="activateView('all')"
                >
                  <Icons class="icon" icon="table" size="48" color="#5d2466"></Icons>
                </div>
              </div>
            </div>

            <transition name="page" mode="out-in">
              <div class="filters-wrapper" v-if="entries.length && showingFilters">
                <div class="filter-wrapper">
                  <el-select size="medium" v-model="filter1.id" placeholder="Select">
                    <el-option
                      v-for="(question, i) in dataSet"
                      :key="question.sys.id"
                      :label="`${i}. ${question.fields.title}`"
                      :value="i">
                    </el-option>
                  </el-select>
                  <el-select size="medium" v-model="filter1.option" placeholder="Select">
                    <el-option
                      v-if="filter1.option"
                      key="filter1-deselect"
                      label="Select"
                      :value="null"
                    >-- Select --</el-option>
                    <el-option
                      v-for="option in getFilterOptions(filter1.id)"
                      :key="option"
                      :label="option"
                      :value="option">
                    </el-option>
                  </el-select>
                </div>
                <div class="filter-wrapper">
                  <el-select size="medium" v-model="filter2.id" placeholder="Select" :disabled="!filter1.option">
                    <el-option
                      v-for="(question, i) in dataSet"
                      :key="question.sys.id"
                      :label="`${i}. ${question.fields.title}`"
                      :value="i"
                    ></el-option>
                  </el-select>
                  <el-select size="medium" v-model="filter2.option" placeholder="Select" :disabled="!filter2.id">
                    <el-option
                      v-if="filter2.option"
                      key="filter2-deselect"
                      label="Select"
                      :value="null"
                    >-- Select --</el-option>
                    <el-option
                      v-for="option in getFilterOptions(filter2.id)"
                      :key="option"
                      :label="option"
                      :value="option">
                    </el-option>
                  </el-select>
                </div>
                <div class="filter-wrapper">
                  <el-select size="medium" v-model="filter3.id" placeholder="Select" :disabled="!filter2.option">
                    <el-option
                      v-for="(question, i) in dataSet"
                      :key="question.sys.id"
                      :label="`${i}. ${question.fields.title}`"
                      :value="i">
                    </el-option>
                  </el-select>
                  <el-select size="medium" v-model="filter3.option" placeholder="Select" :disabled="!filter3.id || !filter2.option">
                    <el-option
                      v-if="filter3.option"
                      key="filter3-deselect"
                      label="Select"
                      :value="null"
                    >-- Select --</el-option>
                    <el-option
                      v-for="option in getFilterOptions(filter3.id)"
                      :key="option"
                      :label="option"
                      :value="option">
                    </el-option>
                  </el-select>
                </div>
                <div class="clear-filters" @click="clearAllFilters()">
                  <Icons class="icon" icon="close" size="48" color="#5d2466"></Icons>
                </div>
              </div>
            </transition>
          </div>

          <div v-if="filtered && filtered.length" class="views">
            <transition-group name="fade">
              <Leaderboard
                class="appearx"
                :entries="filtered"
                :fetching="fetching"
                v-if="view === 'leaderboard'"
                :key="`leader_${entries.length}`"
                ref="leaderboard"
              ></Leaderboard>
              <ProfileStats
                class="appearx"
                :entries="filtered"
                :fetching="fetching"
                v-if="view === 'profileStats'"
                :key="`profile_${entries.length}`"
              ></ProfileStats>
              <AllResponses
                class="appearx"
                :entries="filtered"
                :fetching="fetching || downloading"
                v-if="view === 'all'"
                :key="`all_${entries.length}`"
                ref="all"
              ></AllResponses>
            </transition-group>
          </div>
        </div>
      </section>
      <div class="survey-summary delay-entry delay-like-crazy" v-if="loggedIn && authorized">
        <div class="participants-number">
          Participantes: {{filtered.length}}<br>
          Tiempo promedio: {{averageResponseTime}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TableExport from 'tableexport'
import moment from 'moment'

export default {
  name: 'Analyze',

  data () {
    return {
      downloading: false,
      randomString: '',
      dateTimeout: null,
      showingFilters: false,
      filtered: [],
      filter1: {
        id: null,
        option: null
      },
      filter2: {
        id: null,
        option: null
      },
      filter3: {
        id: null,
        option: null
      },
      entries: [],
      view: 'all',
      startDatetime: this.$store.state.admin.play.startTimestamp,
      endDatetime: this.$store.state.admin.play.endTimestamp,
      repeater: {},
      fetching: false
    }
  },

  components: {
    Icons: () => import('Components/base/Icons'),
    SensataSplash: () => import('Components/base/SensataSplash'),
    AllResponses: () => import('Components/admin/AllResponses'),
    ProfileStats: () => import('Components/admin/ProfileStats'),
    Leaderboard: () => import('Components/admin/Leaderboard')
  },

  computed: {
    dataSet () {
      if (this.$store.state.admin.sidList[this.$route.params.sid]) {
        return this.$store.state.admin.sidList[this.$route.params.sid].dataSet
      }
      return []
    },
    collecting () {
      return this.$store.state.admin.play.status === 'collecting'
    },
    averageResponseTime () {
      if (!this.entries.length) {
        return
      }
      var acc = 0
      this.entries.forEach(entry => {
        if (entry.responses && entry.responses.length >= 1) {
          var totalTime = 0
          entry.responses.forEach((response, index) => {
            if (response && index > 0) {
              totalTime += response.timeToCompletion
              acc += response.timeToCompletion
            }
          })
          entry.calculatedResponseTime = this.secondsToMinutes(totalTime / 1000)
        }
      })

      var value = acc / this.entries.length
      const timeInSecs = Math.round(value / 100) / 10
      var mins = Math.floor(timeInSecs / 60)
      var secs = Math.floor(timeInSecs - mins * 60)
      return `${('00' + mins).slice(-2)}:${('00' + secs).slice(-2)}`
    },
    username () {
      return this.$store.state.user.auth0.name || 'Stranger'
    },
    user () {
      return this.$store.state.user.auth0
    },
    loggedIn () {
      return this.$store.state.user.loggedIn
    },
    survey () {
      return this.$store.state.admin.sidList[this.$route.params.sid]
    },
    surveyName () {
      return this.survey ? this.survey.surveyName : ''
    },
    authorized () {
      const namespace = process.env.VUE_APP_NAMESPACE
      if (this.user && this.user[namespace] && this.user[namespace].sid) {
        return this.user[namespace].sid.indexOf(this.$route.params.sid) > -1
      }
      return false
    },
    profiles () {
      return this.$store.state.testResults.profiles
    },
    queryTimestamp () {
      var d = new Date()
      d.setHours(0, 0, 0, 0)
      return this.$store.state.admin.play.startTimestamp || d.getTime()
    }
  },

  methods: {
    activateView (view) {
      this.view = view
    },
    filterEntries () {
      var one = this.entries.filter(entry => {
        if (this.filter1.option) {
          return entry.responses[this.filter1.id] && entry.responses[this.filter1.id].selected[0] === this.filter1.option
        }
        return entry
      })
      var two = one.filter(entry => {
        if (this.filter2.option && this.filter1.option) {
          return entry.responses[this.filter2.id] && entry.responses[this.filter2.id].selected[0] === this.filter2.option
        }
        return entry
      })
      var three = two.filter(entry => {
        if (this.filter3.option && this.filter2.option && this.filter1.option) {
          return entry.responses[this.filter3.id] && entry.responses[this.filter3.id].selected[0] === this.filter3.option
        }
        return entry
      })
      this.filtered = three
    },
    clearFilter (filterId) {
      this[`filter${filterId}`].option = null
      this.filterEntries()
    },
    clearAllFilters () {
      if (!this.filter1.option && !this.filter2.option && !this.filter3.option) {
        this.showingFilters = false
      }
      this.filter1 = {
        id: null,
        option: null
      }
      this.filter2 = {
        id: null,
        option: null
      }
      this.filter3 = {
        id: null,
        option: null
      }
      this.$nextTick(() => {
        this.filtered = this.entries
      })
    },
    getFilterOptions (id) {
      var table = []
      var options = []
      // TODO: fix for all the question types
      this.entries.forEach(entry => {
        if (entry.responses && entry.responses[id]) {
          table.push(entry.responses[id].selected[0])
        }
      })
      if (table && table.length) {
        options = table.filter((value, index, self) => {
          return self.indexOf(value) === index && value
        })
      }
      return options
    },
    downloadTable (ref) {
      var el = this.$refs[ref].$el
      this.downloading = true
      setTimeout(() => {
        var startDate = moment(this.$store.state.admin.play.startTimestamp).format('YYYY-MM-DD_hhmmss')
        var endDate = moment(this.$store.state.admin.play.endTimestamp || new Date().getTime()).format('YYYY-MM-DD_hhmmss')
        var filename = `${this.surveyName.replace(/-|\s/gi, '_').toLowerCase()}_${this.view}__${startDate}_${endDate}`

        var instance = new TableExport(el, {
          formats: ['csv'],
          exportButtons: false
        })
        var exportData = instance.getExportData()
        var myData = {}
        for (var prop in exportData) {
          if (Object.prototype.hasOwnProperty.call(exportData, prop)) {
            myData = exportData[prop]
          }
        }
        instance.export2file(myData['csv'].data, myData['csv'].mimeType, filename, '.csv')
        this.downloading = false
      }, 1000)
    },
    stopCollecting () {
      clearInterval(this.repeater)
      this.$store.commit('SET_ADMIN_STATE', { status: null })
    },
    goToAdmin () {
      this.$router.push('/admin')
    },
    logIn () {
      localStorage.setItem('redirect_to_url', this.$route.fullPath)
      this.$auth.login()
    },
    // TODO: move this to the api file
    fetchSurveys () {
      if (!this.$store.state.user.loggedIn) {
        return
      }
      var startDatetime = this.$store.state.admin.play.startTimestamp
      var endDatetime = this.$store.state.admin.play.endTimestamp

      this.fetching = true
      Vue.axios({
        method: 'get',
        url: `${process.env.VUE_APP_SURVEY_DATA_ENDPOINT}/surveys`,
        headers: {
          Authorization: `Bearer ${this.$store.state.user.token.accessToken}`
        },
        params: {
          sid: this.$store.state.admin.sid,
          startDatetime: startDatetime || '1564808400000', // August 3 2019 9am
          endDatetime: endDatetime || '2564808400000' // The end of times
        }
      })
        .then(data => {
          console.log('data: ', data)
          this.fetching = false
          this.entries = data.data
          this.filtered = data.data
        })
        .catch(err => {
          console.log('err -force reload: ', err)
        })
    },
    secondsToMinutes (value) {
      var mins = Math.floor(value / 60)
      var secs = Math.floor(value - mins * 60)
      return `${('00' + mins).slice(-2)}:${('00' + secs).slice(-2)}`
    }
  },

  mounted () {
    /*
     * If user is not logged in, redirect
     */
    setTimeout(() => {
      if (!this.loggedIn) {
        localStorage.setItem('redirect_to_url', this.$route.fullPath)
        this.$router.push('/login')
      }
    }, 50)

    this.$store.commit('ADMIN_SET_SID', { surveyId: this.$route.params.sid })

    // Load this survey if non existent
    if (!this.$store.state.admin.sidList[this.$route.params.sid]) {
      this.$store.dispatch('ADMIN_LOAD_SID', { surveyId: this.$route.params.sid})
    }

    this.fetchSurveys(this.$store.state.admin.play.startTimestamp)

    if (!this.profiles && this.$store.state.survey.testResults) {
      this.$store.dispatch('LOAD_TEST_RESULTS', { testResultsId: this.$store.state.survey.testResults.sys.id })
      this.view = 'profileStats'
    }

    // Set up a repeater and reset the event after a while
    if (this.collecting) {
      this.repeater = setInterval(() => {
        this.fetchSurveys(this.$store.state.admin.play.startTimestamp, this.$store.state.admin.play.endTimestamp)
        if ((new Date()).getTime() - 10 * 60000 > this.$store.state.admin.play.startTimestamp) {
          this.stopCollecting()
        }
      }, 10000)
    }
  },

  filters: {
    responseText (val) {
      if (val === 1) {
        return `${val} respuesta`
      }
      return `${val} respuestas`
    }
  },

  watch: {
    'loggedIn': function (newVal) {
      this.fetchSurveys()
    },
    'startDatetime': function (newVal) {
      clearTimeout(this.dateTimeout)
      var timestamp = new Date(newVal).getTime()

      this.$store.commit('SET_ANALYZE_START_TIMESTAMP', { timestamp: timestamp })
      this.dateTimeout = setTimeout(() => {
        this.randomString = Math.random()
        this.fetchSurveys()
      }, 5000)
    },
    'endDatetime': function (newVal) {
      clearTimeout(this.dateTimeout)
      var timestamp = new Date(newVal).getTime()

      this.$store.commit('SET_ANALYZE_END_TIMESTAMP', { timestamp: timestamp })
      this.dateTimeout = setTimeout(() => {
        this.randomString = Math.random()
        this.fetchSurveys()
      }, 5000)
    },
    'filter1.option': function (newVal) {
      this.filterEntries()
    },
    'filter2.option': function (newVal) {
      this.filterEntries()
    },
    'filter3.option': function (newVal) {
      this.filterEntries()
    }
  },

  beforeDestroy () {
    clearInterval(this.repeater)
  }

}
</script>

<style scoped lang="scss">
.view-section {
  justify-content: flex-start !important;
}
.filters-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: flex-start;
}
.filter-wrapper {
  margin-right: 1em;
  max-width: 28%;
  display: flex;
  flex-direction: row;
  select {
    height: 48px;
  }
}
.clear-filters {
  max-width: 26%;
  margin-top: -6px;
  height: 48px;
  &:hover {
    cursor: pointer;
  }
}
.date-selector-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  @include breakpoint($tablet) {
    flex-direction: row;
  }
  > div {
    @include breakpoint($tablet) {
      padding-right: 1em;
    }
  }
}
.secondary-controls {
  padding-right: 2em;
  display: flex;
  flex-direction: row;
}

.participants-number {
  margin-bottom: 1em;
  font-size: 0.8em;
  border-top: 1px solid $gray-light;
  padding-top: 1.5em;
}
.survey-name {
  margin-bottom: 0;
  font-size: 1.5em;
  @include breakpoint($desktop) {
    font-size: 1em;
  }
  @include breakpoint($fullhd) {
    font-size: 1.3em;
  }
}
.responses {
  font-size: 0.9em;
  margin-bottom: 0;
  @include breakpoint($desktop) {
    font-size: 0.7em;
  }
}
.survey-summary {
  min-height: 0;
}
.toolbar {
  margin-bottom: 1em;  
}
.main-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.filter-toolbar {

}
.view-switcher {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  max-width: 40vw;

  .icon-wrapper {
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;
    margin-left: 5px;
    &.active-view {
      opacity: 1;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.79;
    }
    &.icon-reload {
      margin-right: 2px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}

.date-selector {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.collecting-data-wrapper {
  position: relative;
  height: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  .collecting-dot {
    width: 0.5em;
    height: 0.5em;
    border-radius: 100%;
    background: $color-wrapper-emphasis;
    margin-right: 0.5em;
    margin-top: 0.5em;
    animation: bounce-in 1s infinite;
    opacity: 0;
    &:hover {
      cursor: pointer;
    }
    &.active{
      opacity: 1;
    }
  }
}
.disabled {
  opacity: 0.1;
}
</style>

<style lang="scss">
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: $color-wrapper-emphasis !important;
}
.el-select-dropdown__item.selected {
  color: $color-wrapper-emphasis !important;
}
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--datetime {
  input {
    border: none;
    border-bottom: 1px solid $gray-light;
    border-radius: 0;
    font-size: 1.4em !important;
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto !important;
}
.el-select-dropdown__item {
  max-width: 90vw;
  margin: auto;
}
</style>
